/**
 * Parcelas Shopify (Minimog / Dawn)
 * - Até 3x sem juros e de 4x a 12x com juros
 * - Cards (home / coleções): linha sem juros + linha "até 12x com juros"
 * - Página de produto: as mesmas linhas + tabela 1x a 12x que abre e fecha
 * Atualiza sozinho quando a variação ou o preço muda.
 */
(function () {
  // ===== CONFIG =====
  var CONFIG = {
    seletorPreco: '.m-price, .price',   // container de preço do tema (Minimog / Dawn)
    maxParcelas: 12,
    parcelaMinima: 5,                   // valor mínimo de cada parcela (R$)
    semJurosAte: 3,                     // até qual parcela é sem juros
    jurosMensal: 0.0199,                // 1,99% a.m. nas parcelas com juros -> AJUSTE para a taxa real da sua operadora
    textoSemJuros: 'ou <strong>{n}x de {valor}</strong> sem juros',
    textoComJuros: 'ou até <strong>{n}x de {valor}</strong> com juros',
    tituloTabela: 'Ver todas as parcelas'
  };
  // ==================

  var fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  function lerValor(txt) {
    var m = (txt || '').match(/\d{1,3}(?:\.\d{3})*,\d{2}/);
    return m ? parseFloat(m[0].replace(/\./g, '').replace(',', '.')) : 0;
  }

  function precoAtual(priceEl) {
    var sale = priceEl.querySelector('[class*="price-item--sale"]');
    var reg = priceEl.querySelector('[class*="price-item--regular"]');
    var v = sale ? lerValor(sale.textContent) : 0;
    if (!v && reg) v = lerValor(reg.textContent);
    return v;
  }

  function eCard(el) {
    return !!el.closest('.card-wrapper, .card, .product-card, [class*="card-product"], .grid__item, product-recommendations');
  }

  // Valor da parcela: sem juros até CONFIG.semJurosAte, depois Tabela Price
  function valorParcela(preco, n) {
    var i = CONFIG.jurosMensal;
    if (n <= CONFIG.semJurosAte || !i) return preco / n;
    var f = Math.pow(1 + i, n);
    return preco * (i * f) / (f - 1);
  }

  function listarParcelas(preco) {
    var lista = [];
    for (var n = 1; n <= CONFIG.maxParcelas; n++) {
      var v = valorParcela(preco, n);
      if (n > 1 && v < CONFIG.parcelaMinima) break;
      lista.push({ n: n, valor: v, total: v * n, sem: n <= CONFIG.semJurosAte || !CONFIG.jurosMensal });
    }
    return lista;
  }

  function aplicar(modelo, p) {
    return modelo.replace('{n}', p.n).replace('{valor}', fmt.format(p.valor));
  }

  function montarHTML(preco, comTabela) {
    var lista = listarParcelas(preco);
    if (lista.length < 2) return '';

    var ultimaSem = null;
    lista.forEach(function (p) { if (p.sem) ultimaSem = p; });
    var ultima = lista[lista.length - 1];

    var html = '';
    if (ultimaSem && ultimaSem.n >= 2) {
      html += '<p class="parcelas-12x__linha">' + aplicar(CONFIG.textoSemJuros, ultimaSem) + '</p>';
    }
    if (!ultima.sem) {
      html += '<p class="parcelas-12x__linha parcelas-12x__linha--juros">' + aplicar(CONFIG.textoComJuros, ultima) + '</p>';
    }

    if (comTabela) {
      html += '<details class="parcelas-12x__detalhes"><summary>' + CONFIG.tituloTabela + '</summary><table class="parcelas-12x__tabela">';
      lista.forEach(function (p) {
        html += '<tr><td>' + p.n + 'x de ' + fmt.format(p.valor) + '</td><td>' +
          (p.n === 1 ? '' : (p.sem ? 'sem juros' : 'total ' + fmt.format(p.total))) + '</td></tr>';
      });
      html += '</table></details>';
    }
    return html;
  }

  function processar() {
    var produtoPage = location.pathname.indexOf('/products/') > -1;
    document.querySelectorAll(CONFIG.seletorPreco).forEach(function (priceEl) {
      if (priceEl.closest('.parcelas-12x')) return;
      var preco = precoAtual(priceEl);
      var box = priceEl.nextElementSibling;
      if (box && !box.classList.contains('parcelas-12x')) box = null;

      if (!preco || /sold-out/.test(priceEl.className)) {
        if (box) box.remove();
        return;
      }
      if (box && box.getAttribute('data-preco') === String(preco)) return;

      var html = montarHTML(preco, produtoPage && !eCard(priceEl));
      if (!html) { if (box) box.remove(); return; }

      var aberto = box && box.querySelector('details') && box.querySelector('details').open;
      if (!box) {
        box = document.createElement('div');
        box.className = 'parcelas-12x';
        priceEl.insertAdjacentElement('afterend', box);
      }
      box.setAttribute('data-preco', preco);
      box.innerHTML = html;
      if (aberto) box.querySelector('details').open = true;
    });
  }

  var css = document.createElement('style');
  css.textContent =
    '.parcelas-12x{margin:4px 0 8px;font-size:13px;line-height:1.4}' +
    '.parcelas-12x__linha{margin:0}' +
    '.parcelas-12x__linha--juros{font-size:12px;color:#777}' +
    '.parcelas-12x__detalhes{margin-top:8px;border:1px solid #e5e5e5;border-radius:8px;overflow:hidden}' +
    '.parcelas-12x__detalhes summary{cursor:pointer;font-weight:600;padding:10px 12px;background:#f7f7f7;list-style:none}' +
    '.parcelas-12x__detalhes summary::-webkit-details-marker{display:none}' +
    '.parcelas-12x__detalhes summary::after{content:"+";float:right;font-weight:700}' +
    '.parcelas-12x__detalhes[open] summary::after{content:"\\2212"}' +
    '.parcelas-12x__tabela{width:100%;border-collapse:collapse}' +
    '.parcelas-12x__tabela td{padding:8px 12px;border-top:1px solid #eee}' +
    '.parcelas-12x__tabela td:last-child{text-align:right;color:#777}';
  document.head.appendChild(css);

  var timer;
  function agendar() {
    clearTimeout(timer);
    timer = setTimeout(processar, 80);
  }

  function iniciar() {
    processar();
    new MutationObserver(agendar).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();